import React, { useEffect, useState } from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button
} from '@mui/material'
import { useNavigate } from 'react-router-dom'
import DeleteIcon from '@mui/icons-material/Delete'
import { ApiGetAreaManager } from '../../../apiService/Core/Apicall.tsx'

const AreaManager: React.FC = () => {
  const [AreaManagers, setAreaManagers] = useState([])

  useEffect(() => {
    const fetchAreaManagers = async () => {
      try {
        const response = await ApiGetAreaManager()
        setAreaManagers(response.data)
      } catch (error) {
        console.error('Error fetching area managers:', error)
      }
    }

    fetchAreaManagers()
  }, [])
  console.log(AreaManagers)

  const navigate = useNavigate()

  const addOrUpdateAreaManager = (user?: any) => {
    if (user) {
      navigate(`/admin/add-or-update-areamanager/update/${user.areaId}`, {
        state: { areaManager: user },
      })
    } else {
      navigate('/admin/add-or-update-areamanager/add')
    }
  }
  return (
    <div className='manage-admin-container'>
      <div className='manage-button'>
        <h1 className='common-manage-h1'>Area Manager</h1>
        <div className='add-button common-manage-button'>
          <Button
            variant='contained'
            onClick={() => addOrUpdateAreaManager()}
            className='table-row-background '
          >
            Add New Area Manager
          </Button>
        </div>
      </div>
      <Table>
        <TableHead>
          <TableRow className='table-row-background'>
            {["","Area Manager","User Name","Email",""].map((item)=>(<TableCell  style={{ color: '#fff' }} >{item}</TableCell>))}
          </TableRow>
        </TableHead>
        <TableBody>
          {AreaManagers.map((user:any) => (
            <TableRow key={user.areaId}>
              <TableCell>
                <Button variant='contained' className='delete-transparent'>
                  <DeleteIcon className='delete-icon' />
                </Button>
              </TableCell>
              <TableCell>{user.areaName}</TableCell>
              <TableCell>{user.userName}</TableCell>
              <TableCell>{user.emailId}</TableCell>
              <TableCell>
                <Button
                  variant='contained'
                  onClick={() => addOrUpdateAreaManager(user)}
                  className='table-row-background'
                >
                  Edit
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}

export default AreaManager
